<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <input class="search" type="text" [(ngModel)]="search" placeholder="Search users" autocomplete="off" />
            <button class="add-btn" type="button" (click)="openUserModal()">Add new user</button>
        </div>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (users.length === 0) {
            <p class="state-text">No users yet.</p>
        } @else if (filteredUsers.length === 0) {
            <p class="state-text">No users match your search.</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>Username</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Category</th>
                            <th class="center">Active</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (u of filteredUsers; track u.id) {
                            <tr>
                                <td>{{ u.username }}</td>
                                <td>{{ u.name }}</td>
                                <td>{{ u.mobile }}</td>
                                <td>{{ u.email }}</td>
                                <td class="categories">
                                    @if ((u.categoryNames || []).length) {
                                        <span class="chips">
                                            @for (c of u.categoryNames; track c) {
                                                <span class="chip">{{ c }}</span>
                                            }
                                        </span>
                                    } @else {
                                        <span class="muted">—</span>
                                    }
                                </td>
                                <td class="center">
                                    @if (u.active) {
                                        <span class="active-badge" ngbTooltip="Active" container="body">
                                            <fa-icon [icon]="faCheck"></fa-icon>
                                        </span>
                                    } @else {
                                        <span class="inactive-dot" ngbTooltip="Inactive" container="body"></span>
                                    }
                                </td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="openUserModal(u)"
                                        ngbTooltip="Edit" container="body">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(u)"
                                        ngbTooltip="Delete" container="body">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
